import axios from 'axios'

import {message} from "antd"

import moment from 'moment'

// 导入配置文件
import { BASE_URL } from "../config/common"

// 导入 token
import { getStorage, removeStorage } from "./index"

// 创建axios实例
const API = axios.create({
    baseURL: BASE_URL + '/api/'
})

/**
 * 添加请求拦截器
 * 在请求发起之前做一些工作，如，添加头部等
 */
API.interceptors.request.use(config => {
    let { url, page, params }  = config

    // 判断 url 不以 /login
    if (!url.startsWith('user/login')) {
        let { token } = getStorage('user')
        // 满足，自动添加请求头
        config.headers.authorization = token
    }

    // 表示本次请求时一次列表页请求
    if (page !== undefined) {
        // 设置列表 offset 和 limit
        let limit = getStorage('limit', 15)
        config.params.offset = (page - 1) * limit
        config.params.limit = limit
    }

    let op = {}
    if (params !== undefined) {
        let { filter } = params

        // 处理 filter
        if (filter !== null) {
            // 删除为空的字段
            for (var i in filter) {
                if (filter[i] === '') {
                    delete filter[i]
                }

                if (i.indexOf('op_') === 0) {
                    let opName = i.slice(3)
                    if (filter[opName] !== undefined) {
                        op[opName] = filter[i]

                        if (filter[i] === 'RANGE') {
                            let timeArr = filter[opName]
                            if (Array.isArray(timeArr)) {
                                filter[opName] = moment(timeArr[0]).format('YYYY-MM-DD HH:mm:ss') + " - " + moment(timeArr[1]).format('YYYY-MM-DD HH:mm:ss')
                            } else {
                                filter[opName] = moment(timeArr).format('YYYY-MM-DD HH:mm:ss') + " - " + moment(timeArr).endOf('day').format('YYYY-MM-DD HH:mm:ss')
                            }
                        }
                    }

                    delete filter[i]
                }
            }
            config.params.filter = JSON.stringify(filter)
            if (Object.keys(op).length !== 0) {
                config.params.op = JSON.stringify(op)
            }
        }
    }
    return config
})

/**
 * 添加响应拦截器
 * 在请求返回之后做一些工作，如，判断是否请求成功
 */
API.interceptors.response.use(res => {
    let { data, code, msg } = res.data

    // 表示登录过期 | 没有请求权限
    if (code === 1001 || code === 1002) {
        message.error(msg, 1, function () {
            removeStorage('user')
            removeStorage('left_menu')
            removeStorage('right_menu')
            removeStorage('power')
            window.location.hash = 'login'
        })
    }

    // 表示没有数据权限
    if (code === 1003) {
        message.error(msg, 1, function () {
            window.location.reload()
        })
    }

    // 表示失败
    if (code === 0) {
        message.error(msg, 2)
        throw new Error(msg)
    }

    // 表示成功
    if (code === 2) {
        message.success(msg, 2)
    }

    return data
})

export { API }
